class CC_Header {
    constructor(header, options = {}){
        this.options = Object.assign( 
            {},
            {   
                ruptureBurger : 1220,
                promos : {}
            }, 
            options
        );   
 
        this.categories_mob = this.options.categories_mob; 
        this.pastilles_mob = this.options.pastilles_mob; 

        this.burger = document.querySelector("#burger");
        this.header = header;
        this.body = document.querySelector("body");
        this.btnCart = document.querySelector("#btn-cart");
        this.btnCloseCart = document.querySelector("#cart .close");
        this.btnContinueShop = document.querySelector("#cart .close-cart");
        this.btnSearch = document.querySelector("#btn-search");
        this.btnCloseSearch = document.querySelector("#search .close");
        this.closeGlobal = document.querySelectorAll(".close-global");
        this.closeBandeau = document.querySelector("#close-bandeau");
        this.bandeauPromo = document.querySelector(".content-bandeau-promo"); 
        this.contentCategoriesFront = document.querySelector(".menu-left.mob .categories-mob");
        this.contentPastillesFront = document.querySelector(".menu-left.mob .pastilles-mob");
        this.moduleOpen = false; 
        this.sliderBoucle = null;
        this.sliderPromoCurrent = 0; 


        this.hasTouchScreen = false;
        if ("maxTouchPoints" in navigator) {
            this.hasTouchScreen = navigator.maxTouchPoints > 0;
        } else if ("msMaxTouchPoints" in navigator) {
            this.hasTouchScreen = navigator.msMaxTouchPoints > 0;
        } else {
            let mQ = window.matchMedia && matchMedia("(pointer:coarse)");
            if (mQ && mQ.media === "(pointer:coarse)") {
                this.hasTouchScreen = !!mQ.matches;
            } else if ("orientation" in window) {
                this.hasTouchScreen = true; // dépréciée mais utile au cas où
            } else {
            // en dernier recours, on regarde userAgent
            let UA = navigator.userAgent;
            this.hasTouchScreen =
                /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
            }
        }   

        if(this.hasTouchScreen){
            this.header.classList.add("touch");
        } 


        if(this.bandeauPromo != null){
            this.bandeauPromo.addEventListener("click", (e) => {
                e.preventDefault();  
                if (e.target.tagName.toLowerCase() === 'a') {
                    if(e.target.getAttribute("target") != "undefined"){
                        window.open(e.target.href, '_blank'); 
                    }else{
                        window.location.href = e.target.href;
                    } 
                }else{
                    if(this.bandeauPromo.classList.contains("show")){  
                        this.sliderPromoPlay();
                    }else{ 
                        this.sliderPromoPause();
                    }
                    this.bandeauPromo.classList.toggle("show");
                    this.header.classList.toggle("bandeau-open");
                    this.body.classList.toggle('freeze-promo');
                    document.querySelector("html").classList.toggle('freeze-promo');   
                }  
            }); 
        } 
        
    
        this.burger.addEventListener("click", () => {  
            this.header.classList.toggle('menu-open');
            this.burger.classList.toggle('active');
            this.body.classList.toggle('freeze');
            document.querySelector("html").classList.toggle('freeze'); 
        });
    
        if(this.btnCart != null){
            this.btnCart.addEventListener("click", () => {  
                cart.openCart();
            }); 
            this.btnCloseCart.addEventListener("click", () => {
                cart.closeCart();
            });
            this.btnContinueShop.addEventListener("click", () => {
                cart.closeCart();
            });
        }
    
        this.btnSearch.addEventListener("click", () => { 
            this.body.classList.toggle('search-open'); 
            this.body.classList.toggle('freeze');
            document.querySelector("html").classList.toggle('freeze'); 
        }); 
    
        this.btnCloseSearch.addEventListener("click", () => {
            this.body.classList.toggle('search-open'); 
            this.body.classList.toggle('freeze');
            document.querySelector("html").classList.toggle('freeze'); 
        });
    
        this.closeGlobal.forEach(c => {
            c.addEventListener("click", () => {
                this.body.classList.remove('search-open');
                this.body.classList.remove('cart-open'); 
                if(this.header.classList.contains("menu-open")){
                    this.header.classList.remove('menu-open');  
                } 
                if(this.burger.classList.contains("active")){
                    this.burger.classList.remove("active")
                };
                if(this.header.classList.contains("bandeau-open")){
                    this.header.classList.remove('bandeau-open');  
                } 
                if(this.bandeauPromo != null && this.bandeauPromo.classList.contains("show")){
                    this.bandeauPromo.classList.remove("show");
                }
                this.body.classList.remove('freeze');
                document.querySelector("html").classList.remove('freeze'); 
                this.body.classList.remove('freeze-promo');
                document.querySelector("html").classList.remove('freeze-promo'); 
            }); 
        });  
        
        if(this.closeBandeau != null){
            this.closeBandeau.addEventListener("click", () => { 
                this.bandeauPromo.classList.remove("show");
                this.header.classList.remove("bandeau-open");
                this.body.classList.remove('freeze-promo');
                document.querySelector("html").classList.remove('freeze-promo'); 
                this.sliderPromoPlay();
            });  
        }
    
        this.menuLink0 = document.querySelectorAll(".menu-left .link-level0.plus"); 
        this.menuLink0.forEach(m => {
            m.addEventListener("click", (e) => {
                e.preventDefault();
                if(document.querySelector("body").offsetWidth < this.options.ruptureBurger || this.hasTouchScreen){ 
                    m.closest(".cat").classList.toggle("open"); 
                }else{
                    window.location.href = m.getAttribute("href");
                }
            });
        }); 
    
        this.menuLink1 = document.querySelectorAll(".menu-left .level1 h3.plus"); 
        this.menuLink1.forEach(m => {
            m.addEventListener("click", (e) => { 
                if(document.querySelector("body").offsetWidth < this.options.ruptureBurger){ 
                    e.preventDefault();
                    m.closest(".level1").classList.toggle("open"); 
                } 
            });
        });    
        document.addEventListener("cssLoaded", () => {
            document.querySelectorAll(".toload").forEach(l => {
            l.classList.add("loaded");
            });
        });  
    
        document.querySelectorAll(".link-target").forEach(l => {
            l.addEventListener("click", (e) => {
                e.preventDefault();
                let target = document.querySelector(l.getAttribute("href"));
                let targetPos = target.offsetTop;
                let headerH = document.querySelector("#header").offsetHeight;
                window.scroll(0, targetPos-headerH);
            });
        });

        if(typeof this.options.promos.promos_count != "undefined" && this.options.promos.promos_count > 0 && this.bandeauPromo != null){
            this.buildPromos();
        }

        this.buildCategories(this.categories_mob.categories);
        console.log("pastilles", this.pastilles_mob.pastilles);
        this.buildPastilles(this.pastilles_mob.pastilles);
         
    }

    buildCategories(categories){  
        let arImage = [];
        let contentCategories = this.createElementWithClass("div", "categories");
        categories.forEach(cat => {
            let contentCat = this.createElementWithClass("a", "categorie");
            contentCat.href = cat.url;
            let contentCatImg = this.createElementWithClass("div", "content-img");
            let imgCat = this.createElementWithClass("img", "img-cat");
            imgCat.classList.add("lazy");
            imgCat.classList.add("ext");
            imgCat.setAttribute("data-src", cat.img);
            imgCat.setAttribute("alt", contentCat);
            contentCatImg.appendChild(imgCat);
            let contentCatDesc = this.createElementWithClass("div", "content-desc");
            contentCatDesc.innerHTML = cat.title;
            contentCat.appendChild(contentCatImg);  
            contentCat.appendChild(contentCatDesc); 
            contentCategories.appendChild(contentCat);  
            arImage.push(imgCat); 
        }); 
        this.contentCategoriesFront.appendChild(contentCategories);  
        new LazyLoader(arImage);
    }

    buildPastilles(pastilles){  
        let arImage = [];
        let contentPastilles = this.createElementWithClass("div", "pastilles");
        pastilles.forEach(pas => {
            let contentPas = this.createElementWithClass("a", "pastille");
            contentPas.href = pas.url;
            let contentPasImg = this.createElementWithClass("div", "content-img");
            let imgCat = this.createElementWithClass("img", "img-cat");
            imgCat.classList.add("lazy");
            imgCat.classList.add("ext");
            imgCat.setAttribute("data-src", pas.img);
            imgCat.setAttribute("alt", contentPas);
            contentPasImg.appendChild(imgCat);
            let contentPasDesc = this.createElementWithClass("div", "content-desc");
            contentPasDesc.innerHTML = pas.title;
            contentPas.appendChild(contentPasImg);  
            contentPas.appendChild(contentPasDesc); 
            contentPastilles.appendChild(contentPas);  
            arImage.push(imgCat); 
        }); 
        this.contentPastillesFront .appendChild(contentPastilles);  
        new LazyLoader(arImage);
    }

    buildPromo(promo){
        let lab = this.createElementWithClass("div", "p");
        lab.innerHTML = promo.desc;
        lab.setAttribute("data-desc-plus", promo.desc_plus);
        return lab;
    }

    buildPromos(){ 
        this.options.promos.promos.forEach(promo => {
            let lab = this.buildPromo(promo);
            document.querySelector(".content-bandeau-promo .slider-promo .slider").appendChild(lab);
        });  
        document.querySelector(".content-bandeau-promo .text .content-hide").innerHTML = this.options.promos.promos[0].desc_plus;
        if(this.options.promos.promos_count > 1){
            let lab = this.buildPromo(this.options.promos.promos[0]);
            document.querySelector(".content-bandeau-promo .slider-promo .slider").appendChild(lab);
            this.sliderPromoPlay();
        }
        document.querySelector(".content-bandeau-promo").style.background = this.options.promos.color_bg; 
        document.querySelector(".content-bandeau-promo, .content-bandeau-promo a").style.color = this.options.promos.color_txt;
        document.querySelector(".content-bandeau-promo svg").style.fill = this.options.promos.color_txt;
        document.querySelector(".content-bandeau-promo .text .content-hide").style.background = this.options.promos.color_bg;
        document.querySelector(".content-bandeau-promo").classList.add("on");
    }

    resetSliderPromo(){ 
        this.sliderPromoCurrent = 0;
        document.querySelector(".content-bandeau-promo .slider-promo .slider").style.transition = 'all 0s ease';
        document.querySelector(".content-bandeau-promo .slider-promo .slider").style.transform = `translateY(0px)`; 
         
        /*
        setTimeout(() => {
            document.querySelector(".content-bandeau-promo .slider-promo .slider").style.transition = 'all 0.3s ease'; 
        }, 100);
        */
        document.querySelector(".content-bandeau-promo .slider-promo .slider").offsetHeight;
        document.querySelector(".content-bandeau-promo .slider-promo .slider").style.transition = ""; 
    }

    sliderPromoPause(){ 
        clearInterval(this.sliderBoucle);
        this.sliderBoucle = null;
    } 

    sliderPromoPlay(){ 
        if (this.sliderBoucle) {
            clearInterval(this.sliderBoucle);
            this.sliderBoucle = null;
        }
        this.sliderBoucle = setInterval(() => { 
            this.sliderPromoCurrent++; 
            const slider = document.querySelector(".content-bandeau-promo .slider-promo .slider");
            const calT = -(this.sliderPromoCurrent * this.heightSlider);
            slider.style.transition = 'transform 0.3s ease';
            slider.style.transform = `translateY(${calT}px)`;

            if (this.sliderPromoCurrent === this.options.promos.promos_count) {
                setTimeout(() => {
                    slider.style.transition = 'none'; 
                    slider.style.transform = 'translateY(0px)';
                    this.sliderPromoCurrent = 0;
    
                    slider.offsetHeight;
                    slider.style.transition = 'transform 0.3s ease';

                    document.querySelector(".content-bandeau-promo .text .content-hide").innerHTML = this.options.promos.promos[0].desc_plus;
                }, 300); 
            } else {
                document.querySelector(".content-bandeau-promo .text .content-hide").innerHTML =
                    this.options.promos.promos[this.sliderPromoCurrent].desc_plus;
            }
        }, 2000); 
    } 

    getParams(parameterName) {
        var result = null,
            tmp = [];
        location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
        tmp = item.split("=");
        if (decodeURIComponent(tmp[0]) === parameterName) result = decodeURIComponent(tmp[1]);
        });
        return result;
    } 

    createElementWithClass(type, className){
        var element = document.createElement(type);
        element.classList.add(className);
        return element;
    }

    get heightSlider(){
        return document.querySelector(".slider-promo").offsetHeight;
    }
}
   
